var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "interface-arrows-button-up--arrow-up-keyboard",
    clipPath: "url(#clip0_237_2946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.75087 0.357117L7.14373 4.74997C7.17789 4.78204 7.20512 4.82076 7.22374 4.86376C7.24235 4.90676 7.25195 4.95312 7.25195 4.99997C7.25195 5.04683 7.24235 5.09319 7.22374 5.13618C7.20512 5.17918 7.17789 5.21791 7.14373 5.24997L2.75087 9.64283",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_237_2946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "matrix(0 1 -1 0 10 0)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow_right.42e0946a8c40c14ea04964c0e420f71f.svg";